<template>
  <div class="box10"></div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.box10 {
  width: 100%;
  height: 300px;
  background: url("../../../assets/coursePage/cPuls/box10.png") no-repeat;
  background-size: cover;
  background-position-x: center;
}
</style>